export const EndpointNameAuth = {
  REFRESH: '/token/refresh/',
  LOGIN: '/token/',
  VERIFY: '/token/verify/',
}

export const EndpointNameUsers = {
  GET_CURRENT_USER: '/users/users/me/',
  ALL_USERS: '/users/users/',
  CLIENTS: '/clients/clients/',
  ACCOUNTANTS: '/users/accountants/',
  INVESTORS: '/users/investors/',
}

export const EndpointNameObjects = {
  GET_OBJECTS: '/obyektlar/buildings/',
  CREATE_OBJECT: '/obyektlar/buildings/',
  UPDATE_OBJECT: '/obyektlar/buildings/',
  DELETE_OBJECT: '/obyektlar/buildings/',
  GET_UNSOLD_ROOMS: '/obyektlar/sections/',
  GET_ALL_BLOCKS: '/obyektlar/blocks/',
}

export const EndpointNameBlocks = {
  GET_BLOCKS: '/obyektlar/buildings/',
  ADD_BLOCK: '/obyektlar/buildings/',
  DELETE_BLOCK: '/obyektlar/blocks/',
  GET_BLOCK_BY_ID: '/obyektlar/blocks',
  GET_SECTIONS_OF_BLOCK: '/obyektlar/blocks',
  GET_SECTION_BY_ID: '/obyektlar/sections',
  ADD_SECTION: '/obyektlar/blocks',
  UPDATE_SECTION: '/obyektlar/sections',
  DELETE_SECTION: '/obyektlar/blocks/delete-section/',
  DELETE_ROOM: '/obyektlar/rooms',
  UPDATE_ROOM: '/obyektlar/rooms',
  GET_ALL_BLOCKS: '/obyektlar/buildings/',
}

export const EndpointNameExpenses = {
  GET_EXPENSES: '/expenses/expenses/',
  GET_EXPENSES_BY_ID: '/expenses/expenses/',
  ADD_EXPENSE: '/expenses/expenses/',
  UPDATE_EXPENSE: '/expenses/expenses/',
  GET_ALL_INVESTS: '/expenses/invests/',
  GET_EXPENSE_STATS: '/expenses/expenses/statistics/',
}

export const EndpointNameStaffs = {
  GET_STAFFS: '/staffs/staffs/',
  GET_STAFF_BY_ID: '/staffs/staffs/',
  ADD_STAFF: '/staffs/staffs/',
  UPDATE_STAFF: '/staffs/staffs/',
  DELETE_STAFF: '/staffs/staffs/',
}

export const EndpointNameDashboard = {
  MONITORING: 'dashboard/monitoring/',
  STATISTICS: 'dashboard/statistics/',
  ROOM_STATISTICS: 'dashboard/room-statistics/',
}

export const EndpointNameAccountants = {
  GET_ACCOUNTANTS: '/users/accountants/',
  ADD_ACCOUNTANTS: '/users/accountants/',
}

export const EndpointNameBronClients = {
  BRON_CLIENTS: '/clients/bron-clients/',
}
